import {
  GET_TEAM_CONTRACTS,
  GET_TEAM_CONTRACTS_ERROR,
  GET_TEAM_CONTRACTS_SUCCESS,
} from "../modules/team/actions/teamActions";
import AuthFetch from "../auth/AuthFetch";
import type { Middleware } from "@reduxjs/toolkit";

const apiEndpoint = `${import.meta.env.API_ENDPOINT}/api/Team`;

const teamApi: Middleware = (store) => (next) => (action) => {
  next(action);
  switch (action.type) {
    case GET_TEAM_CONTRACTS: {
      AuthFetch(fetch, `${apiEndpoint}/teamContracts`)
        .then((response) => response.json())
        .then((data) => {
          return next({
            type: GET_TEAM_CONTRACTS_SUCCESS,
            payload: {
              data: data,
            },
          });
        })
        .catch((err) => {
          return next({
            type: GET_TEAM_CONTRACTS_ERROR,
            payload: {
              data: err,
            },
          });
        });
      break;
    }
    default:
      return store;
  }
};

export default teamApi;
